document.addEventListener('DOMContentLoaded', () => {
  const getThumbnails = () =>
    document.querySelectorAll('zoom-dialog .dialog-thumbnails-list__thumbnail');

  const getActiveIndex = (thumbs) => {
    return [...thumbs].findIndex((btn) => btn.getAttribute('aria-selected') === 'true');
  };

  const goNext = () => {
    const thumbs = getThumbnails();
    if (!thumbs.length) return;

    let current = getActiveIndex(thumbs);
    if (current === -1) current = 0;

    const next = (current + 1) % thumbs.length;
    thumbs[next].click();
  };

  const goPrev = () => {
    const thumbs = getThumbnails();
    if (!thumbs.length) return;

    let current = getActiveIndex(thumbs);
    if (current === -1) current = 0;

    const prev = (current - 1 + thumbs.length) % thumbs.length;
    thumbs[prev].click();
  };

  document.querySelectorAll('.zoom-next').forEach((button) => {
    button.addEventListener('click', goNext);
  });

  document.querySelectorAll('.zoom-prev').forEach((button) => {
    button.addEventListener('click', goPrev);
  });



document.addEventListener('mouseover', function (e) {
  const img = e.target.closest('.dialog-zoomed-gallery .product-media-container .product-media img');
  if (!img) return;

  const container = img.closest('.product-media-container');
  if (!container) return;

  let lens = container.querySelector('.simple-magnifier');
  if (!lens) {
    lens = document.createElement('div');
    lens.className = 'simple-magnifier';
    container.appendChild(lens);
  }

  const zoom = 2.2;
  const lensSize = 120;

  function moveLens(ev) {
    const rect = img.getBoundingClientRect();
    const containerRect = container.getBoundingClientRect();

    const x = ev.clientX - rect.left;
    const y = ev.clientY - rect.top;

    if (x < 0 || y < 0 || x > rect.width || y > rect.height) {
      lens.style.display = 'none';
      return;
    }

    let left = ev.clientX - containerRect.left - lensSize / 2;
    let top = ev.clientY - containerRect.top - lensSize / 2;

    const maxLeft = containerRect.width - lensSize;
    const maxTop = containerRect.height - lensSize;

    left = Math.max(0, Math.min(left, maxLeft));
    top = Math.max(0, Math.min(top, maxTop));

    lens.style.display = 'block';
    lens.style.left = left + 'px';
    lens.style.top = top + 'px';
    lens.style.backgroundImage = `url("${img.currentSrc || img.src}")`;
    lens.style.backgroundSize = `${rect.width * zoom}px ${rect.height * zoom}px`;
    lens.style.backgroundPosition = `-${x * zoom - lensSize / 2}px -${y * zoom - lensSize / 2}px`;
  }

  function hideLens() {
    lens.style.display = 'none';
    container.removeEventListener('mousemove', moveLens);
    container.removeEventListener('mouseleave', hideLens);
  }

  container.addEventListener('mousemove', moveLens);
  container.addEventListener('mouseleave', hideLens);
});


});




/*document.addEventListener('DOMContentLoaded', () => {
  const getThumbnails = () =>
    document.querySelectorAll('zoom-dialog .dialog-thumbnails-list__thumbnail');
  const getActiveIndex = (thumbs) => {
    return [...thumbs].findIndex(btn =>
      btn.getAttribute('aria-selected') === 'true'
    );
  };
  document.querySelector('.zoom-next')?.addEventListener('click', () => {
    const thumbs = getThumbnails();
    if (!thumbs.length) return;
    let current = getActiveIndex(thumbs);
    if (current === -1) current = 0;
    let next = (current + 1) % thumbs.length;
    thumbs[next].click();
  });

  document.querySelector('.zoom-prev')?.addEventListener('click', () => {
    const thumbs = getThumbnails();
    if (!thumbs.length) return;
    let current = getActiveIndex(thumbs);
    if (current === -1) current = 0;
    let prev = (current - 1 + thumbs.length) % thumbs.length;
    thumbs[prev].click();
  });
});

*/
